<template>
  <el-dialog
    title="新增计算规则"
    :visible.sync="isShow"
    width="600px"
    :close-on-click-modal="false"
    :before-close="handleClose"
  >
    <el-form
      :model="ruleForm"
      :rules="ruleRules"
      ref="ruleFormRef"
      label-width="120px"
    >
      <!-- 规则名称 -->
      <el-form-item label="规则名称" prop="ruleName">
        <el-input
          v-model="ruleForm.ruleName"
          placeholder="请输入规则名称"
          maxlength="50"
          clearable
        />
      </el-form-item>

      <!-- 房产类型 -->
      <el-form-item label="房产类型" prop="propertyType">
        <el-select
          v-model="ruleForm.propertyType"
          placeholder="请选择房产类型"
          style="width: 100%"
        >
          <el-option
            v-for="(item, index) in propertyTypeOptions"
            :key="index"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>

      <!-- 新增：费用类型 -->
      <el-form-item label="费用类型" prop="feeType">
        <el-select
          v-model="ruleForm.feeType"
          placeholder="请选择费用类型"
          style="width: 100%"
        >
          <el-option
            v-for="(item, index) in feeTypeOptions"
            :key="index"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>

      <!-- 每平米价格 -->
      <el-form-item label="每平米价格" prop="pricePerSqm">
        <el-input
          v-model="ruleForm.pricePerSqm"
          placeholder="请输入每平米价格(元/㎡)"
          type="number"
          step="0.01"
          min="0"
          clearable
        />
        <span class="unit">元/㎡</span>
      </el-form-item>

      <!-- 规则描述 -->
      <el-form-item label="规则描述" prop="ruleDesc">
        <el-input
          v-model="ruleForm.ruleDesc"
          placeholder="请输入规则描述（可选）"
          type="textarea"
          :rows="3"
          maxlength="500"
          show-word-limit
        />
      </el-form-item>
      <el-form-item label="状态" prop="isEnabled">
        <el-switch
          v-model="ruleForm.isEnabled"
          :active-value="1"
          :inactive-value="0"
          active-text="启用"
          inactive-text="禁用"
        />
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" @click="handleSubmit">确认</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { addCalcRule } from "@/api/community/calcRuleApi";

export default {
  name: "AddCalcRule",
  data() {
    return {
      isShow: false,
      // 表单数据：新增 feeType（费用类型）
      ruleForm: {
        ruleId: "", // 主键ID（UUID）
        ruleName: "", // 规则名称
        propertyType: "", // 房产类型
        feeType: "", // 新增：费用类型（rent=房租/heating=采暖）
        pricePerSqm: "", // 每平米价格
        effectiveTime: new Date(), // 生效时间
        expireTime: "", // 过期时间（可选）
        isEnabled: 1, // 状态：1-启用，0-禁用
        ruleDesc: "", // 规则描述（可选）
      },
      // 表单校验规则：新增 feeType 必选校验
      ruleRules: {
        ruleName: [
          { required: true, message: "请输入规则名称", trigger: "blur" },
          { max: 50, message: "规则名称不能超过50个字符", trigger: "blur" },
        ],
        propertyType: [
          { required: true, message: "请选择房产类型", trigger: "change" },
        ],
        feeType: [
          { required: true, message: "请选择费用类型", trigger: "change" },
        ],
        pricePerSqm: [
          { required: true, message: "请输入每平米价格", trigger: "blur" },
        ],
      },
      // 房产类型下拉选项
      propertyTypeOptions: [
        { value: "10", label: "住宅" },
        { value: "20", label: "商业" },
        { value: "30", label: "工业" },
        { value: "40", label: "商铺" },
      ],
      // 新增：费用类型下拉选项（房租/采暖）
      feeTypeOptions: [
        { value: "rent", label: "房租" },
        { value: "heating", label: "采暖" },
      ],
    };
  },
  methods: {
    // 打开弹窗
    open() {
      // 先判断表单引用是否存在，再执行重置
      if (this.$refs.ruleFormRef) {
        this.$refs.ruleFormRef.resetFields();
      }
      // 初始化表单数据（包含新增的feeType）
      this.ruleForm = {
        ruleId: "",
        ruleName: "",
        propertyType: "",
        feeType: "", // 初始化费用类型为空
        pricePerSqm: "",
        effectiveTime: new Date(),
        expireTime: "",
        isEnabled: 1,
        ruleDesc: "",
      };
      this.isShow = true;
      console.log("子组件弹窗状态已设置为显示");
    },

    // 关闭弹窗
    handleClose() {
      this.isShow = false;
      // 重置表单，避免下次打开有残留数据
      if (this.$refs.ruleFormRef) {
        this.$refs.ruleFormRef.resetFields();
      }
    },

    // 提交表单
    async handleSubmit() {
      try {
        // 1. 表单校验
        await this.$refs.ruleFormRef.validate();

        // 2. 数据预处理（包含feeType，确保字段类型正确）
        const submitData = {
          ...this.ruleForm,
          pricePerSqm: Number(this.ruleForm.pricePerSqm), // 转换为数字
          feeType: this.ruleForm.feeType, // 携带费用类型参数
        };

        // 3. 调用新增接口
        await addCalcRule(submitData);

        // 4. 操作成功反馈
        this.$message.success("新增计算规则成功");
        this.isShow = false;

        // 5. 触发父组件刷新列表
        this.$emit("success");
      } catch (error) {
        // 错误处理（区分表单校验错误和接口错误）
        if (error.name !== "Error") {
          // 表单校验错误，无需额外处理（Element UI已显示提示）
          return;
        }
        console.error("新增计算规则失败:", error);
        this.$message.error("新增计算规则失败，请重试");
      }
    },
  },
};
</script>

<style scoped>
/* 单位样式 */
.unit {
  margin-left: 10px;
  color: #666;
  font-size: 14px;
}

/* 提示文本样式 */
.tip {
  margin-left: 10px;
  color: #999;
  font-size: 12px;
}

/* 弹窗底部按钮样式 */
.dialog-footer {
  text-align: right;
}

/* 适配textarea字数统计样式 */
.el-input__count {
  color: #999;
  font-size: 12px;
}
</style>
